$(document).ready(function () {
  var $block = $('.events-list-block');
  function checkForScrollbar() {
    if (721 < window.innerWidth < 1200) {
      if ($block.find('.js-results-wrapper').outerWidth() < $block.find('.js-results').outerWidth()) {
        $block.find('.events-list-block__results').addClass('has-horizontal-scrollbar');
      }
      else {
        $block.find('.events-list-block__results').removeClass('has-horizontal-scrollbar');
      }
    }
  }
  checkForScrollbar();
  window.addEventListener('resize', checkForScrollbar);

  $block.find('button[aria-expanded]').click(function () {
    var $this = $(this);
    var id = $this.attr('aria-controls');
    if ($this.attr('aria-expanded') == 'true') {
      $block.find('#' + id).hide();
      $this.attr('aria-expanded', false);
    }
    else {
      $block.find('#' + id).show();
      $this.attr('aria-expanded', true);
    }
  });
})